import { ActivityCategory, ActivityDifficulty } from "@/graphql/graphql";

export const TEXT_DEBOUNCE_MS = 500;

export const ACTIVITY_CATEGORIES = Object.values(ActivityCategory);

// Forcing the order of the difficulty options to match the order of the difficulty enum
// Making it a Record forces TS compiler to check that all keys in the enum are used.
const ORDERED_DIFFICULTY_OPTIONS: Record<ActivityDifficulty, true> = {
  [ActivityDifficulty.Easy]: true,
  [ActivityDifficulty.Medium]: true,
  [ActivityDifficulty.Hard]: true,
};

// Forcing cast to ActivityDifficulty[] is safe here because we know that keys are
// ActivityDifficulty. Necessary because Object.keys is typed as string[].
export const ACTIVITY_DIFFICULTIES = Object.keys(
  ORDERED_DIFFICULTY_OPTIONS
) as ActivityDifficulty[];
